import { useNavigate } from "react-router-dom";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const handleInquire = () => {
    navigate("/contact", {
      state: {
        productName: product.name,
        message: `I would like to inquire about ${product.name}. Please provide more details about pricing, availability, and specifications.`,
      },
    });
  };

  return (
    <div className="product-card">
      <div className="product-image">
        {product.image && <img src={product.image} alt={product.name} />}
      </div>
      <div className="product-info">
        <div className="product-name">{product.name}</div>
        <div className="product-price">{product.price}</div>
        <div className="product-description">{product.description}</div>
      </div>
      <button className="inquire-btn" onClick={handleInquire}>
        Get Quote
      </button>
    </div>
  );
};

export default ProductCard;
